import { useQuery } from '@tanstack/react-query';

import { fetchAdditionalFields } from '@ManagerPortal/api/account';

import { AdditionalField } from '../../Main/autoApiTypes';
import { SCHEDULE_DATA_CACHE_TIME } from '../useFetchScheduleData';
import { useGetScheduleDataHookParams } from '../utils/useGetScheduleDataHookParams';

export const QUERY_KEY = '/v1/employee/additional-fields/by-group';

export const useAdditionalFieldsQuery = <T = AdditionalField>(
  select: (data?: AdditionalField[]) => T,
) => {
  const { currentGroupId: groupId } = useGetScheduleDataHookParams();

  const additionalFieldsQuery = useQuery({
    queryKey: [QUERY_KEY, groupId],
    queryFn: async () => {
      const response = await fetchAdditionalFields(groupId);
      return response?.body;
    },
    select,
    cacheTime: SCHEDULE_DATA_CACHE_TIME,
  });

  return additionalFieldsQuery;
};
